import React from "react";
import { observer } from "mobx-react";
import HtmlViewer from "@app/components/html/viewer";

import "./style/additional-data.scoped.scss";

const AdditionalData = observer(({ data }) => {
    return (
        <div className="fieldContainer">
            <div className="fieldLabel">
                <span className="text">{data?.title}</span>
            </div>

            {data?.value && (
                <div className="fieldContent">
                    <HtmlViewer html={data.value} />
                </div>
            )}

            {data?.ai?.suggestion && (
                <>
                    <br />
                    <div className="fieldLabel">
                        <span className="text">AI Suggestion</span>
                    </div>

                    <div className="fieldContent">
                        <HtmlViewer html={data.ai.suggestion} />
                    </div>
                </>
            )}
        </div>
    );
});

export default AdditionalData;
